<script setup>
import { computed, ref } from 'vue'
import { SearchIcon } from '@heroicons/vue/solid'
import {
  Combobox,
  ComboboxButton,
  ComboboxInput,
  ComboboxLabel,
  ComboboxOption,
  ComboboxOptions,
} from '@headlessui/vue'
import { usePage } from "@inertiajs/inertia-vue3";
import { Inertia } from '@inertiajs/inertia'

function visitProductPage() {
  if(selectedProduct.value) {
    Inertia.visit(route('rentable.detail', selectedProduct.value.slug))
    selectedProduct.value = null;
  }
}

const products = computed(() => usePage().props.value.searchableProducts);

const query = ref('')
let selectedProduct = ref( null)
const filteredProducts = computed(() =>
  query.value === ''
    ? products
    : usePage().props.value.searchableProducts.filter((product) => {
      return product.name.toLowerCase().includes(query.value.toLowerCase())
    })
)
</script>

<template>
  <Combobox as="div" v-model="selectedProduct" :onChange="visitProductPage()">
    <div class="relative mt-1 w-full">
      <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
        <SearchIcon class="h-5 w-5 text-gray-400" aria-hidden="true" />
      </div>
      <ComboboxInput
        as="input"
        placeholder="Zoeken"
        class="block w-full pl-10 pr-3 py-2 border border-transparent rounded-md leading-5 text-gray-300 placeholder-gray-400 focus:outline-none focus:bg-white focus:border-white focus:ring-white focus:text-gray-900 sm:text-sm"
        @change="query = $event.target.value" :display-value="(product) => product?.name" />
      <ComboboxButton class="absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none">
      </ComboboxButton>

      <ComboboxOptions v-if="filteredProducts.length > 0" class="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
        <ComboboxOption v-for="product in filteredProducts" :key="product.id" :value="product" as="template" v-slot="{ active, selected }">
          <li :class="['relative cursor-default select-none py-2 pl-3 pr-9', active ? 'bg-primary text-white' : 'text-gray-900']">
            <span :class="['block truncate', selected && 'font-semibold']">
              {{ product.name }}
            </span>
          </li>
        </ComboboxOption>
      </ComboboxOptions>
    </div>
  </Combobox>
</template>
